import { IsNotEmpty, IsString, IsOptional, IsArray } from 'class-validator';
import { IBaseResponse } from './base-response.dto';
import { IForm, IFormField } from './form.dto';

export interface ICrmSchema {
  _id?: string;
  name: string;
  description: string;
  organization: string;
  createdAt?: string;
  updatedAt?: string;
  /** form array, each form act as group for related fields */
  content?: ICrmSchemaGroup[];
}

export interface ICrmSchemaGroup {
  _id?: string;
  description?: string;
  fields: IFormField[];
  /** act as a field, the field name will be the group name and its value will be the fields value
   *  ex: lead.address
   * */
  isCoreSchemaField?: boolean;
  /** required if isCoreSchemaField is true */
  name?: string;
}

/* -------------------------------------------------------------------------- */
/*                               Create new CrmSchema                              */
/* -------------------------------------------------------------------------- */

export class CreateCrmSchemaDto {
  @IsNotEmpty()
  @IsString()
  name: string;

  @IsString()
  @IsOptional()
  description?: string;
  @IsString()
  @IsOptional()
  organization?: string;
  @IsArray()
  @IsOptional()
  content?: IForm[];
}

export interface CreateCrmSchemaResponse extends IBaseResponse {
  crmSchema: ICrmSchema;
}

/* -------------------------------------------------------------------------- */
/*                                   Update CrmSchema                              */
/* -------------------------------------------------------------------------- */

export class UpdateCrmSchemaDto {
  @IsOptional()
  @IsString()
  title: string;
  @IsString()
  @IsOptional()
  description?: string;
  @IsArray()
  @IsOptional()
  content: IForm[];
}

export interface UpdateCrmSchemaResponse extends IBaseResponse {
  id: string;
}

/* -------------------------------------------------------------------------- */
/*                                  Get CrmSchemas                                 */
/* -------------------------------------------------------------------------- */
export class GetCrmSchemasDto {}

export type GetCrmSchemasResponse = ICrmSchema[];
